export { default as ListarPuestos } from './Listar';
export { default as NuevoPuesto } from './Crear';